import {isLeafTypeNumerical} from 'data-types/benchling-type-def/BenchlingTypeDef';

import {DisableFunctionParams, FieldUISchemaWithStandardComponent} from '../StepConfigEditorTypes';
import {maybeGetValueFromConfig} from './StepConfigSettingsUtils';

export function isEditorDisabled({
  uiSchema,
  config,
  columns,
}: DisableFunctionParams & {
  uiSchema: FieldUISchemaWithStandardComponent;
}): boolean {
  if (!uiSchema.disableFn) {
    return false;
  }
  return uiSchema.disableFn({config, columns});
}

function isColumnNumeric({
  config,
  columns,
  configShapePath,
}: DisableFunctionParams & {configShapePath: Array<string>}): boolean {
  const columnSystemName = maybeGetValueFromConfig(config, configShapePath);
  const column = columns.find((col) => col.systemName === columnSystemName);
  return column != null && isLeafTypeNumerical(column.type.leafType);
}

export function isXAxisColumnNameNotNumeric({config, columns}: DisableFunctionParams): boolean {
  return !isColumnNumeric({
    config,
    columns,
    configShapePath: ['chartConfig', 'parameters', 'xAxisColumnName'],
  });
}

function isConfigFieldNull({
  config,
  configShapePath,
}: DisableFunctionParams & {configShapePath: Array<string>}): boolean {
  const value = maybeGetValueFromConfig(config, configShapePath);
  return value == null;
}

export function isSeriesColumnNameNull({config, columns}: DisableFunctionParams): boolean {
  return isConfigFieldNull({
    config,
    columns,
    configShapePath: ['chartConfig', 'parameters', 'seriesColumnName'],
  });
}
